import {Component, ElementRef, ViewChild} from '@angular/core';
import {NgbActiveModal, NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {ComponentInstanceComponent} from './component-instance/component-instance.component';
import {ComponentsService} from 'src/app/services/components.service';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {ToastService} from '../toast/toast.service';
import {LanguageService} from 'src/app/shared/language/language.service';


@Component({
  selector: 'app-components-maintenance',
  templateUrl: './components-maintenance.component.html',
  standalone: false
})
export class ComponentsMaintenanceComponent {

  listComponents: any[] = [];
  listComponentsDet: any[] = [];
  idproyecto !: number;
  idioma !: string;
  formComp: FormGroup;
  componentId !: string;
  usuario !: string;
  enabledAttribute: boolean = true;

  listProduct: any[] = [];
  listProjectComponent: any[] = [];
  @ViewChild('modalDeleteComponent') modalDeleteComponent!: ElementRef;
  @ViewChild('confirmdelete') confirmdelete!: ElementRef;

  colsProjectComponent: any[] = [];
  rowSelectedProjectC: any;

  constructor(public modal: NgbActiveModal,
              private __componentService: ComponentsService,
              private __toastService: ToastService,
              public modalO: NgbModal,
              private fb: FormBuilder,
              private __languageService: LanguageService) {
    this.formComp = this.fb.group({
      component: ['', Validators.required],
      product: ['', Validators.required]
    });
  }

  ngOnInit(): void {
    this.colsProjectComponent = this.getColsProjectComponent();
    this.__componentService.findResources(this.idproyecto, this.idioma).subscribe((resp: any) => {
      if (resp['an_resultado'] == 0) {
        this.listComponents = resp['listComponents'];
        this.listProduct = resp['listProduct'];
        this.listProjectComponent = resp['listProjectComponent'];
      }
    })
  }

  init() {
    this.__componentService.findResources(this.idproyecto, this.idioma).subscribe((resp: any) => {
      if (resp['an_resultado'] == 0) {
        this.listComponents = resp['listComponents'];
        this.listProduct = resp['listProduct'];
        this.listProjectComponent = resp['listProjectComponent'];
        this.formComp.get('component')!.patchValue(this.componentId);
        this.formComp.get('component')!.disable()
      }
    })
  }

  newInstance() {
    let modalRef = this.modalO.open(ComponentInstanceComponent, {size: 'sm'});
    modalRef.componentInstance.componentid = (this.formComp.getRawValue().component ? this.formComp.getRawValue().component : this.componentId);
    modalRef.componentInstance.usuario = 'IGOTELLI';
    modalRef.componentInstance.idioma = this.idioma;
    modalRef.componentInstance.idproyecto = this.idproyecto;
    modalRef.componentInstance.intSfdcQuotelineId = this.formComp.get('product')?.value;
  }

  cleanAll() {
    this.cleanFields()
    this.enabledAttribute = true;
    this.listComponentsDet = [];
  }

  cleanFields() {
    this.formComp = this.fb.group({
      component: ['', Validators.required],
      product: ['', Validators.required]
    });
  }

  isValid(controlName: any) {
    let ep: any;
    ep = this.formComp.get(controlName);
    return ep.invalid && ep.touched;
  }

  openDeleteComponent() {
    this.modalO.open(this.modalDeleteComponent, {size: 'xlg', backdrop: 'static'});
  }

  getColsProjectComponent() {
    return [{
      field: 'COMPONENT_DESC',
      header: this.__languageService.obtTexto('dataform.new_component.table.component_desc')
    },
      {
        field: 'PRODUCT_NAME',
        header: this.__languageService.obtTexto('dataform.new_component.table.product_name')
      },
      {
        field: 'USUREG',
        header: this.__languageService.obtTexto('dataform.new_component.table.user_reg')
      },
      {
        field: 'FECREG',
        header: this.__languageService.obtTexto('dataform.new_component.table.date_reg')
      },
      {
        field: 'IDCOMPONENT',
        header: this.__languageService.obtTexto('dataform.new_component.table.action')
      }]
  }

  confirmDeleteProjectComponent(data: any) {
    this.modalO.open(this.confirmdelete, {size: 'sm'});
    this.rowSelectedProjectC = data;
  }

  deleteProjectComponent() {
    this.__componentService.actionInstanceComponent(this.rowSelectedProjectC, 'D').subscribe((resp: any) => {
      console.log(resp)
      if (resp['an_resultado'] == 0) {
        this.__toastService.show(resp['ac_mensaje'], {type: 'success'});
        setTimeout(() => {
          window.location.reload()
        }, 1000);
      } else {
        this.__toastService.show(resp['ac_mensaje'], {type: 'error'});
      }
    });
  }
}
